// components/Middleware/requireguest.component.jsx
import React from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/authcontext";
import Loader from "../Loader/Loader";

function RequireGuest({ children, fallback = null }) {
    const { t } = useTranslation();
    const { auth, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <Loader message={t('common.loading')} />;
    }

    if (auth.isAuthenticated) {
        return fallback || <Navigate to="/dashboard" state={{ from: location }} replace />;
    }

    return children;
}

RequireGuest.propTypes = {
    children: PropTypes.node.isRequired,
    fallback: PropTypes.node,
};

export default RequireGuest;
